// extracted by mini-css-extract-plugin
export default {"triggerContainer":"EditCustomerButton_triggerContainer__ZW9A6"};